import DebitNoteCrud from "../components/debit-note/DebitNoteCrud";

const DebitNotesPage = () => {
  return <DebitNoteCrud />;
};

export default DebitNotesPage;
